import React from 'react'
import alt from '../content/alt'
import { colors, alpha, s, grid } from '../style'

const Feature = ({ title, subtitle, desc, icon, count }) => {
  return (
    <div
      css={[
        sFeature,
        count < 7 && {
          [s.lg]: {
            maxWidth: grid(4),
            flexBasis: grid(4),
          },
        },
      ]}>
      <img src={icon} alt={title + alt} className='feature-image' />
      <h3 css={{ display: 'flex', flexDirection: 'column' }}>
        <span className='feature-subtitle'>{subtitle}</span>
        <span className='feature-title'> {title} </span>
      </h3>
      <p className='feature-desc'>{desc}</p>
    </div>
  )
}

const sFeature = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginBottom: '6rem',
  [s.sm_down]: {
    marginBottom: '6rem',
  },

  [s.xs]: {
    maxWidth: grid(12),
    flexBasis: grid(12),
  },
  [s.sm]: {
    maxWidth: grid(6),
    flexBasis: grid(6),
  },
  [s.md]: {
    maxWidth: grid(4),
    flexBasis: grid(4),
  },
  [s.lg]: {
    maxWidth: grid(3),
    flexBasis: grid(3),
  },

  '.feature-image': {
    height: 64,
    width: 'auto',
    marginBottom: '2rem',
  },

  '.feature-subtitle': {
    color: colors.brand,
    fontSize: '1.125rem',
    fontWeight: 600,
    textAlign: 'center',
    letterSpacing: '-0.025em',
  },

  '.feature-title': {
    textAlign: 'center',
    color: colors.brand,
    fontSize: '2rem',
    lineHeight: '1.25em',
    fontWeight: 800,
    letterSpacing: '-0.05em',
    textTransform: 'uppercase',
    margin: '0.25rem 0rem 0.75rem',
    background: `linear-gradient(to right, ${
      colors.white
    }, ${colors.white.concat(alpha[30])})`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    [s.ss]: {
      fontSize: '1.5rem',
    },
  },

  '.feature-desc': {
    lineHeight: '1.618em',
    fontSize: '0.75rem',
    opacity: 0.3,
    textAlign: 'center',
    maxWidth: 300,
    fontWeight: 300,
    letterSpacing: '-0.0125em',
  },
}

export default Feature
